// @i18n-ignore-file
export const LB_USER_ID_HEADER = 'x-lb-user-id'
export const REGION_ID_HEADER = 'x-gctx-request-origin-region-id'
export const REGION_LANG_HEADER = 'x-gctx-request-origin-locale'
export const CANARY_GROUP_ID_HEADER = 'x-gctx-canary-group-id'
export const COUNTRY_HEADER = 'cloudfront-viewer-country'
export const STORE_PROGRAM_ID_HEADER = 'x-store-program-id'
export const VELOU_FILTERS_HEADER = 'x-show-dynamic-filters'
export const SUBSCRIPTION_EXP_ENABLED_HEADER = 'x-exp-subscription-enabled'
export const PERSONALISATION_ENABLED_HEADER = 'x-personalisation-enabled'

// PL layout-fetch enrichment version. `V2` = the SVD/VDA-native enrichment (emits PRODUCT_PURCHASE_V2 &
// friends), sent only behind the SVD flag. There is deliberately NO `V1` value: PL's legacy enrichment is
// what an ABSENT header selects, so a non-SVD session omits the header entirely (see `buildPLHeaders`).
export const ENRICH_VERSION_HEADER = 'x-enrich-version'
export const ENRICH_VERSION_VALUES = {
  V2: 'V2',
} as const

export const CONTENT_TYPE_HEADER = 'Content-Type'
export const XML_CONTENT_TYPE = 'text/xml'

export const B2B_TENANT_HEADER = 'x-b2b-tenant' // eslint-disable-line
export const B2B_PROGRAM_HEADER = 'x-b2b-program' // eslint-disable-line
export const B2B_FEATURE_PREVIEW_HEADER = 'xq-original-host' // eslint-disable-line
